import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BenefeciariesService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'Benefeciaries';

    super(http, authenticationSerives, baseUrl);
  }
}
